export const logo = require('../../assets/images/HailSolve-Logo.png');